import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchPersonalArchiveFoldersSuccess } from "../actions/Archive";
import { fetchOrganizationArchiveFoldersSuccess } from "../actions/Archive";
import { ShowSuccess, ShowError } from "../../helper/Alert";
import { goBack } from 'connected-react-router';
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getPersonalArchiveFolders = async (archiveId: any | null) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`Archive/getPersonalArchiveFolders?searchText=&parentId=${archiveId}`);
}

const getOrganizationArchiveFolders = async (organizationArchiveId: any | null) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`Archive/getArchiveFolders?searchText=&parentId=${organizationArchiveId}`);
}

const setPersonalArchive = async (archiveModel: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("archive/personalArchive", archiveModel);
}

const setOrgnizationArchive = async (archiveModel: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("archive/Archive", archiveModel);
}

const fastArchive = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("archive/employeePositionFastArchive", parameters);
}

//Fast Archive
function* onFastArchiveRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(fastArchive, action.payload);
        // yield put(onFastArchiveSuccess());
        ShowSuccess(messages["messages.FastArchiveSuccessfullyDone"], "");
        yield put(goBack())
    } catch (error) {
        return ShowError("", error);
    }
}

export function* FastArchiveRequest() {
    yield takeEvery(ActionTypes.FAST_ARCHIVE, onFastArchiveRequest);
}

//Personal
function* personalArchive(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(setPersonalArchive, action.payload);
        // yield put(onSetPersonalArchiveSuccess());
        ShowSuccess(messages["messages.PersonalArchiveSuccessfullyDone"], "");
        yield put(goBack())
    } catch (error) {
        return ShowError("", error);
    }
}

export function* setPersonalArchiveRequest() {
    yield takeEvery(ActionTypes.SET_PERSONAL_ARCHIVE, personalArchive);
}

//Organization
function* orgnizationArchive(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(setOrgnizationArchive, action.payload);
        // yield put(onSetOrganizationArchiveSuccess());
        ShowSuccess(messages["messages.OrganizationArchiveSuccessfullyDone"], "");
        yield put(goBack())
    } catch (error) {
        return ShowError("", error);
    }
}

export function* setOrganizationArchiveRequest() {
    yield takeEvery(ActionTypes.SET_ORGANIZATION_ARCHIVE, orgnizationArchive);
}

function* fetchPersonalArchiveFoldersRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedPersonalArchiveFolders = yield call(getPersonalArchiveFolders, action.payload);
        yield put(fetchPersonalArchiveFoldersSuccess(fetchedPersonalArchiveFolders.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchPersonalArchiveFolders() {
    yield takeEvery(ActionTypes.GET_PERSONAL_ARCHIVE_FOLDERS, fetchPersonalArchiveFoldersRequest);
}

function* fetchOrganizationArchiveFoldersRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedOrganizationArchiveFolders = yield call(getOrganizationArchiveFolders, action.payload);
        yield put(fetchOrganizationArchiveFoldersSuccess(fetchedOrganizationArchiveFolders.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchOrganizationArchiveFolders() {
    yield takeEvery(ActionTypes.GET_ORGANIZATION_ARCHIVE_FOLDERS, fetchOrganizationArchiveFoldersRequest);
}

export default function* rootSaga() {
    yield all([fork(fetchPersonalArchiveFolders), fork(fetchOrganizationArchiveFolders), fork(setPersonalArchiveRequest), fork(setOrganizationArchiveRequest), fork(FastArchiveRequest)]);
}

